import { ApiManager } from "../../core/api-manager";
import { DataManager } from "../../core/data-manager";
import { settings } from "../../config/settings";
import { LanguageProvider } from "../../core/language-provider";

export function onInsert(response, entity, data) {}
